import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Navbar.css'; // Import the CSS file

const Navbar = ({ logout }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    logout(); // Call the logout function passed as a prop
    navigate('/', { replace: true }); // Navigate to the login page and replace history
    window.location.reload(); // Force a full page refresh to clear cache
  };

  return (
    <nav className="navbar">
      <div className="navbar-brand p-0 ms-2"><img src="/logo_ds5.png" width={100} /></div>
      <ul className="nav-links">
        <li><Link to="/app/client-dashboard">Dashboard</Link></li>
        <li><Link to="/app/tester-interface">Test Reports</Link></li>
        <li><Link to="/app/user-settings">Settings</Link></li> 
        <li><Link to="/app/operator-management">Operator Management</Link></li> {/* Nouveau lien */}

      </ul>
      <button className="logoutButton" onClick={handleLogout}>Logout</button>
    </nav>
  );
};

export default Navbar;